import { CREATURES } from './combatData';
import { KEYSTONES } from './keystoneCards';

export const RANKABLE_ENEMIES = CREATURES.map((creature) => ({
  id: creature.pool,
  category: 'enemy',
  name: creature.name,
  icon: creature.icon,
}));

export const HTN_REGIMEN_DRUGS = [
  ['lisinopril', 'Lisinopril'],
  ['enalapril', 'Enalapril'],
  ['benazepril', 'Benazepril'],
  ['losartan', 'Losartan'],
  ['valsartan', 'Valsartan'],
  ['olmesartan', 'Olmesartan'],
  ['amlodipine', 'Amlodipine'],
  ['nifedipine', 'Nifedipine'],
  ['felodipine', 'Felodipine'],
  ['verapamil', 'Verapamil'],
  ['diltiazem', 'Diltiazem'],
  ['metoprolol', 'Metoprolol'],
  ['atenolol', 'Atenolol'],
  ['bisoprolol', 'Bisoprolol'],
  ['carvedilol', 'Carvedilol'],
  ['nebivolol', 'Nebivolol'],
  ['labetalol', 'Labetalol'],
  ['hydrochlorothiazide', 'Hydrochlorothiazide'],
  ['chlorthalidone', 'Chlorthalidone'],
  ['indapamide', 'Indapamide'],
  ['furosemide', 'Furosemide'],
  ['torsemide', 'Torsemide'],
  ['bumetanide', 'Bumetanide'],
  ['spironolactone', 'Spironolactone'],
  ['eplerenone', 'Eplerenone'],
  ['amiloride', 'Amiloride'],
  ['triamterene', 'Triamterene'],
  // Nephron-expansion diuretics (2026-07-25): not true antihypertensives, added
  // to the standalone roster so the nephron figure covers all five segments and
  // the two new segments become blister-pullable. Weak/niche by design.
  ['acetazolamide', 'Acetazolamide'],
  ['mannitol', 'Mannitol'],
];

const drugById = new Map();
KEYSTONES.forEach((keystone) => {
  drugById.set(keystone.id, {
    id: keystone.id,
    category: 'drug',
    name: keystone.genericName,
  });
});
HTN_REGIMEN_DRUGS.forEach(([id, name]) => {
  drugById.set(id, { id, category: 'drug', name });
});

export const RANKABLE_DRUGS = Array.from(drugById.values());

const enemyById = new Map(RANKABLE_ENEMIES.map((element) => [element.id, element]));
const rankableDrugById = new Map(RANKABLE_DRUGS.map((element) => [element.id, element]));

function resolveRankable(ids, registry) {
  const seen = new Set();
  return (ids || []).flatMap((rawId) => {
    const id = typeof rawId === 'string' ? rawId.trim().toLowerCase() : '';
    if (!id || seen.has(id) || !registry.has(id)) return [];
    seen.add(id);
    return [registry.get(id)];
  });
}

export function resolveRankableEnemies(ids) {
  return resolveRankable(ids, enemyById);
}

export function resolveRankableDrugs(ids) {
  return resolveRankable(ids, rankableDrugById);
}

export function resolveRankableRegimenDrugs(regimen, supplementalIds = []) {
  const cardSlugs = Array.isArray(regimen?.card_slugs) ? regimen.card_slugs : [];
  return resolveRankableDrugs([...cardSlugs, ...(supplementalIds || [])]);
}
